import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView } from '@/components/base'
import { NotificationItem } from '@/components/NotificationItem'
import { MockNotification } from '@/mock/notifications'

export interface NotificationsListProps {
  data: MockNotification[]
}

export const NotificationsList: React.FC<NotificationsListProps> = ({
  data,
}) => {
  const { t } = useTranslation()

  const handleNotificationItem = (item: MockNotification) => {
    switch (item.type) {
      case 'kem-support':
        return {
          title: t('translation:kemSupport'),
          nextButtonLabel: t('translation:goToChat'),
        }

      default:
        return {
          title: t('screens:notifications.notifications'),
          nextButtonLabel: '',
        }
    }
  }

  const handleButtonNext = () => {
    // TODO: Implement navigation logic based on notification type
  }

  return (
    <BaseView
      fullWidth
      style={{
        marginTop: '20px',
        paddingLeft: '12px',
        paddingRight: '12px',
      }}
    >
      {data.map((item, index) => {
        const handledItem = handleNotificationItem(item)

        return (
          <BaseView key={item.id} fullWidth>
            <NotificationItem
              title={handledItem.title}
              nextButtonLabel={handledItem.nextButtonLabel}
              onButtonNext={() => handleButtonNext(item)}
              {...item}
            />

            {/* Separator (except for last item) */}
            {index < data.length - 1 && (
              <BaseView
                fullWidth
                style={{
                  height: '12px',
                }}
              />
            )}
          </BaseView>
        )
      })}
    </BaseView>
  )
}
